import React from "react";

import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";

export const RoomHeightCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    const roomHeight =
        property.height_range.lower === property.height_range.upper
            ? `${property.height_range.lower} cm wysokości`
            : `od ${property.height_range.lower} do ${property.height_range.upper} cm wysokości`;

    return <>{roomHeight}</>;
};
import React from "react";

import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";

export const RoomHeightCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    const roomHeight =
        property.height_range.lower === property.height_range.upper
            ? `${property.height_range.lower} cm wysokości`
            : `od ${property.height_range.lower} do ${property.height_range.upper} cm wysokości`;

    return <>{roomHeight}</>;
};
